import Flickity from 'flickity';
import IMGFlickity from 'flickity-imagesloaded';
import BGLazyLoadFlickity from 'flickity-bg-lazyload';

// flickering fix for ie
const focus = Flickity.prototype.focus;
Flickity.prototype.focus = function () {
    // use non-standard setActive for IE11. #651
    if (this.element.setActive) {
        this.element.setActive();
        return;
    }
    // use default
    focus.apply(this, arguments);
};

// flickity height fix
Flickity.prototype._createResizeClass = function () {
    setTimeout(() => {
        this.element.classList.add('flickity-resize');
    });
};
Flickity.createMethods.push('_createResizeClass');

const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
    this.element.classList.remove('flickity-resize');
    resize.call(this);
    this.element.classList.add('flickity-resize');
};


/**
 * *******************************
 * images carousel
 * *******************************
 */
const imgCarousels = document.querySelectorAll('.img-carousel-container');
const createImgCarousel = function (carouselContainer) {
    const cCarousel = carouselContainer.querySelector('.img-carousel');
    new Flickity(cCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        arrowShape: 'M44.2917 49.1275L51.7083 38.9079C52.2252 38.1992 53.2824 37.8522 54.2927 38.0595C55.303 38.2667 56 38.9802 56 39.7949L55.9843 60.2099C55.9843 61.0246 55.2873 61.7333 54.277 61.9405C53.2668 62.1478 52.2095 61.8007 51.7004 61.0921L44.2996 50.9014C43.9002 50.3519 43.9002 49.6818 44.2996 49.1323'
    });
};
imgCarousels.forEach((elem) => {
    createImgCarousel(elem);
});

/**
 * *******************************
 * testimonial carousel
 * *******************************
 */
const testimonialCarousels = document.querySelectorAll(
    '.testimonial-carousel-container'
);
let tFlickity = null;
const createTCarousel = function (carouselContainer) {
    const tCarousel = carouselContainer.querySelector('.testimonial-carousel');
    const tCarouselStatus = carouselContainer.querySelector(
        '.testimonial-carousel-status'
    );
    tFlickity = new Flickity(tCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        on: {
            select: function (index) {
                if (tCarouselStatus) {
                    tCarouselStatus.textContent = `${index + 1} of ${
                        this.slides.length
                    }`;
                }
            },
        },
    });
};
testimonialCarousels.forEach((elem) => {
    createTCarousel(elem);
});

// resolve the font loading issue, which causes the different height
document.fonts.ready.then(function () {
    if (tFlickity) {
        tFlickity.resize();
    }
});

/**
 * *******************************
 * banner carousel
 * *******************************
 */
const bannerCarousels = document.querySelectorAll('.banner-carousel-container');
const createBCarousel = function (carouselContainer) {
    const bCarousel = carouselContainer.querySelector('.banner-carousel');
    new Flickity(bCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        bgLazyLoad: 1,

        // Note: add custom arrow (need to draw it in a 100 × 100 viewbox)
        arrowShape: 'M44.2917 49.1275L51.7083 38.9079C52.2252 38.1992 53.2824 37.8522 54.2927 38.0595C55.303 38.2667 56 38.9802 56 39.7949L55.9843 60.2099C55.9843 61.0246 55.2873 61.7333 54.277 61.9405C53.2668 62.1478 52.2095 61.8007 51.7004 61.0921L44.2996 50.9014C43.9002 50.3519 43.9002 49.6818 44.2996 49.1323'
    });

    // Note: make every .carousel-cell/.banner-contents the same height in the mobile view
    if(window.innerWidth < 768) {
        const bannerContents = bCarousel.querySelectorAll('.banner-contents');
        const bannerContentsHeights = [];

        Object.values(bannerContents).map((item) => {
            bannerContentsHeights.push(item.offsetHeight);
        });

        // get the highest value
        const setHeightValue = Math.max(...bannerContentsHeights);

        // set every .banner-contents' height to the setHeightValue
        Object.values(bannerContents).map((item) => {
            item.style.height = setHeightValue + "px";
        });
    }
};
bannerCarousels.forEach((elem) => {
    createBCarousel(elem);
});

/**
 * *******************************
 * cta carousel
 * *******************************
 */
const ctaCarousels = document.querySelectorAll('.cta-carousel-container');
const createCCarousel = function (carouselContainer) {
    const cCarousel = carouselContainer.querySelector('.cta-carousel');
    new Flickity(cCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        bgLazyLoad: 1,

        // Note: enable/disable Flickity
        watchCSS: true,
    });
};
ctaCarousels.forEach((elem) => {
    createCCarousel(elem);
});

/**
 * *******************************
 * partners carousel
 * *******************************
 */
const partnersCarousels = document.querySelectorAll('.partners-carousel-container');
const createPaCarousel = function (carouselContainer) {
    const paCarousel = carouselContainer.querySelector('.partners-carousel');
    new Flickity(paCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        bgLazyLoad: 1,

        // Note: enable/disable Flickity
        watchCSS: true,
    });
};
partnersCarousels.forEach((elem) => {
    createPaCarousel(elem);
});

/**
 * *******************************
 * gallery carousel
 * *******************************
 */
const galleryCarousels = document.querySelectorAll(
    '.gallery-carousel-container'
);

const createGCarousel = function (carouselContainer) {
    const gCarousel = carouselContainer.querySelector('.gallery-carousel');
    const gCarouselStatus = carouselContainer.querySelector(
        '.gallery-carousel-status'
    );
    new BGLazyLoadFlickity(gCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        bgLazyLoad: 1,
        on: {
            select: function (index) {
                if (gCarouselStatus) {
                    if (gCarousel.classList.contains('media')) {
                        gCarouselStatus.textContent = `Photo ${index + 1} of ${
                            this.slides.length
                        }`;
                    } else {
                        gCarouselStatus.innerHTML = `<strong>${index + 1}/${
                            this.slides.length
                        }</strong>${
                            this.selectedElement.querySelector('.sr-only')
                                .textContent
                        }`;
                    }
                }
            },
        },
    });
};

galleryCarousels.forEach((elem) => {
    createGCarousel(elem);
});

/**
 * *******************************
 * article carousel
 * *******************************
 */
const articleCarousels = document.querySelectorAll(
    '.article-carousel-container'
);

const createACarousel = function (carouselContainer) {
    const aCarousel = carouselContainer.querySelector('.article-carousel');
    new Flickity(aCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        watchCSS: true,
    });
};

articleCarousels.forEach((elem) => {
    createACarousel(elem);
});

/**
 * *******************************
 * pagelink carousel
 * *******************************
 */
const pagelinkCarousels = document.querySelectorAll(
    '.pagelink-carousel-container'
);

const createPCarousel = function (carouselContainer) {
    const pCarousel = carouselContainer.querySelector('.pagelink-carousel');
    new Flickity(pCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        watchCSS: true,
    });
};

pagelinkCarousels.forEach((elem) => {
    createPCarousel(elem);
});
